import { useEffect } from 'react';

export function RedirectToGuest(props) {
    useEffect(() => {
        const guestUrl = process.env.REACT_APP_ENV === 'local'
            ? `${process.env.REACT_APP_LOCAL_SECURE}/reservations`
            : `${process.env.REACT_APP_SECURE}/reservations`;
        
        window.location.href = guestUrl;
    }, []);

    return null;
}
